import { createAction } from 'redux-actions';

export const onChangeQuery = createAction('INVENTORY_ON_CHANGE_QUERY');

export const onClearQuery = createAction('INVENTORY_ON_CLEAR_QUERY');
